var module;
// LICENSE_CODE ZON
'use strict'; /*jslint node:true, browser:true*/

var is_node = typeof module == 'object' && module.exports;
if (is_node) ;else ;
define('/www/hola/pub/site_load.js', ['/util/user_agent.js', 'hola_opt', 'hola_config', '/www/hola/pub/experiment_init', '/www/hola/pub/lib/use_browser.ts', 'pub_config', 'cookie', '/util/util.js', '/util/url.js'], function (user_agent, hopt, inc_config, experiment_init, use_browser_m, pub_config, cookie, zutil, zurl) {
  var perr = inc_config.perr || function () {};
  experiment_init = experiment_init.default;
  var use_browser = use_browser_m.use_browser;
  var E = {};
  E.GDL = {
    firefox_signed: {
      name: 'Firefox Signed',
      cls: 'firefox_signed',
      url: '/firefox_signed_last.xpi'
    },
    chrome: {
      name: 'Chrome',
      cls: 'chrome',
      url: 'https://chromewebstore.google.com/detail/' + 'hola-vpn-the-website-unbl/gkojfkhlekighikafcpjkiklfbnlmeio',
      adremover_url: 'https://chrome.google.com/webstore/detail/hola-adblock' + '/lalfpjdbhpmnhfofkckdpkljeilmogfl',
      va_url: 'https://chrome.google.com/webstore/detail/hola-video-' + 'accelerator/chgpmaaockmdehmidghebcjafhihlgha'
    },
    opera: {
      name: 'Opera',
      cls: 'opera',
      url: 'https://addons.opera.com/en/extensions/details/hola-better-' + 'internet/',
      id: 'ekmmelpnmfdegjhnmadddcfjcahpajnm'
    },
    edge: {
      name: 'Edge',
      cls: 'edge',
      url: 'https://microsoftedge.microsoft.com/addons/detail/' + 'eibinhpjpbkmjeohlclnebmkhdfehpbf',
      adremover_url: 'https://microsoftedge.microsoft.com/addons/detail/' + 'pejdjolhgfenbjfjoejgllffflbbgecm',
      id: 'eibinhpjpbkmjeohlclnebmkhdfehpbf'
    },
    android: {
      name: 'Android',
      cls: 'android'
    },
    android_premium: {
      name: 'Android',
      cls: 'android'
    },
    android_va: {
      name: 'Android',
      cls: 'android',
      url: 'market://details?id=org.hola.va'
    },
    windows: {
      name: 'Windows',
      cls: 'windows',
      url: '/download/windows'
    },
    mac: {
      name: 'Mac OS',
      cls: 'mac',
      url: '/download/mac'
    },
    ios: {
      name: 'iPhone/iPad',
      cls: 'ios',
      url: 'https://itunes.apple.com/us/app/hola-vpn/' + 'id1553473179?mt=8'
    },
    xbox: {
      name: 'Xbox/Xbox 360/Xbox One',
      cls: 'xbox',
      url: '/plus_setup?platform=console&type=xbox_one'
    },
    ps: {
      name: 'Playstation/Playstation 2/Playstation 3/Playstation 4',
      cls: 'ps',
      url: '/plus_setup?platform=console&type=ps4'
    }
  };
  Object.defineProperty(E.GDL.android, 'url', {
    get: function get() {
      if (!hopt.www_hola.link_download_apk) return 'market://details?id=org.hola';
      return hopt.www_hola.link_download_apk;
    }
  });
  Object.defineProperty(E.GDL.android_premium, 'url', {
    get: function get() {
      if (!hopt.www_hola.link_download_apk) return 'market://details?id=org.hola.play';
      return hopt.www_hola.link_download_apk;
    }
  });
  function ga_send(type, category, action, label, non_interaction) {
    window.ga(function () {
      window.ga('send', {
        hitType: type,
        eventCategory: category,
        eventAction: action,
        eventLabel: label,
        nonInteraction: non_interaction
      });
    });
  }
  E.get_inline_url = function (url) {
    var tokens = /\/(?:hola-adblock|hola-better-internet|hola-video-accelerator)/gi;
    return url.replace(tokens, '');
  };
  E.inline_adremover_url = E.get_inline_url(E.GDL.chrome.adremover_url);
  E.inline_va_url = E.get_inline_url(E.GDL.chrome.va_url);
  function is_agreed(_hopt, opt) {
    return opt && (opt.agree || opt.agreed_in_ext) && (_hopt.www_hola.enable_install_exe_agreed_win || window.location.search.includes('test=exe_flow'));
  }
  function is_lum_promo(opt) {
    return opt && opt.lum_promo;
  }
  function is_uninstall_flow(opt) {
    return opt && opt.uninstall_flow;
  }
  function is_extension_flow(opt) {
    return opt && opt.extension_flow;
  }
  function is_install_flow(opt) {
    return opt && opt.install_flow;
  }
  function is_mac_install_flow(_hopt, opt) {
    return opt && (opt.mac_installer || _hopt.www_hola.mac_installer);
  }
  function is_ext_vpn_flow(_hopt, opt) {
    return opt && opt.ext_vpn;
  }
  function is_firefox_flow(opt) {
    return opt && opt.firefox && !opt.os;
  }
  function is_firefox_jn_flow(opt, b) {
    return opt && (opt.firefox || b == 'firefox') && opt.from_jn && !opt.os;
  }
  function is_opera_flow(opt) {
    return opt && opt.opera && !opt.os;
  }
  function is_opera_jn_flow(opt, b) {
    return opt && (opt.opera || b == 'opera') && opt.from_jn && !opt.os;
  }
  function is_edge_flow(opt) {
    return opt && opt.edge && !opt.os;
  }
  function is_edge_jn_flow(opt, b) {
    return opt && (opt.edge || b == 'edge') && opt.from_jn && !opt.os;
  }
  function is_chrome_flow(opt) {
    return opt && opt.chrome && !opt.os;
  }
  function is_chrome_jn_flow(opt, b) {
    return opt && (opt.chrome || b == 'chrome') && opt.from_jn && !opt.os;
  }
  function is_banner_flow(opt) {
    return opt && opt.banner;
  }
  function is_email_flow(opt) {
    return opt && opt.email;
  }
  function is_no_consent_flow(opt) {
    return opt && opt.noconsent;
  }
  function is_ios_flow(opt) {
    return opt && opt.ios;
  }
  function is_online_vpn_flow(opt) {
    return opt && opt.online_vpn;
  }
  function is_web_installer_flow(opt) {
    return opt && opt.web;
  }
  E.is_win_installer_v2 = function (_hopt, sys) {
    var sys_win_installer_v2 = _hopt.www_hola.sys_win_installer_v2_re || [];
    var is_v2_enabled = sys_win_installer_v2.some(function (_sys) {
      var conf_keys = Object.keys(_sys);
      return conf_keys.every(function (c_key) {
        var r_exp = new RegExp(_sys[c_key]);
        return r_exp.test(sys[c_key]);
      });
    });
    return is_v2_enabled;
  };
  E.get_exe_link = function (_hopt, sys, versions, opt) {
    if (!opt) opt = {};
    var url_d = _hopt.cdn4_host || pub_config.cdn_url;
    var special_countries = _hopt.www_hola.use_site_for_download || [];
    if (special_countries.indexOf((_hopt.user_country || '').toUpperCase()) > -1) url_d = pub_config.backend_url;
    var filename = E.get_exe_filename(_hopt, sys, versions, opt);
    if (sys.os == 'macos' && !opt.os || opt.os == 'macos') {
      if (opt.hola_browser && !hopt.www_hola.no_mac_browser || is_mac_install_flow(_hopt, opt)) {
        return url_d + '/static/setup/' + versions.mac_installer + '/' + filename;
      }
      return url_d + '/static/' + filename;
    }
    if (opt.version) {
      return url_d + '/static/' + filename + '?web_installer=' + opt.version;
    }
    var ver = versions.web_installer;
    var ver_v2 = versions.web_installer_v2;
    if (sys.os != 'windows' || E.is_win_installer_v2(_hopt, sys)) {
      return url_d + '/static/v2/' + filename + '?web_installer_v2=' + ver_v2 + '&product=' + (opt.hola_browser ? 'browser' : '');
    }
    return url_d + '/static/' + filename + '?web_installer=' + ver;
  };
  var get_cmp_conf = function get_cmp_conf(c_type, type) {
    return zutil.get(hopt, 'www_hola.campaigns.' + type, []).find(function (c) {
      return c.name == c_type || c.cam_id && c_type.startsWith(c.name);
    });
  };
  E.get_exe_filename = function (_hopt, sys, versions, opt) {
    if (!opt) opt = {};
    var os = sys.os == 'macos' && !opt.os || opt.os == 'macos' ? 'mac' : 'windows';
    var is_mac = os == 'mac';
    var cmp_conf;
    if (opt.hola_browser && !(hopt.www_hola.no_mac_browser && is_mac)) {
      var fn_browser = !is_mac ? hopt.www_hola.hola_browser_name : hopt.www_hola.mac_installer_browser;
      var fn_ext = is_mac ? '.zip' : '.exe';
      // XXX dmitriiz: don't add campaign from cookie for mac
      if (is_mac && fn_browser) {
        return fn_browser.indexOf(fn_ext) == -1 ? fn_browser + fn_ext : fn_browser;
      }
      if (!is_mac && E.is_win_installer_v2(_hopt, sys)) fn_browser = hopt.www_hola.hola_browser_name_v2;
      var ab_tests = is_mac ? [] : [];
      var is_a = ab_tests.some(function (x) {
        return experiment_init.ui_test[x] === true;
      });
      var is_b = ab_tests.some(function (x) {
        return experiment_init.ui_test[x] === false;
      });
      if (is_a) fn_browser = fn_browser.replace(fn_ext, '-C-hpa' + fn_ext);else if (is_b) fn_browser = fn_browser.replace(fn_ext, '-C-hpb' + fn_ext);else {
        var c_browser = cookie.get('c_browser');
        if (c_browser && c_browser != 'organic') {
          cmp_conf = get_cmp_conf(c_browser, 'browser');
          var pref = '';
          if (is_agreed(_hopt, opt)) pref += '-Agreed';
          if (cmp_conf && cmp_conf.infix) pref += cmp_conf.infix;
          fn_browser = fn_browser.replace(fn_ext, pref + '-C-' + c_browser + fn_ext);
        }
      }
      return fn_browser;
    }
    var file_name;
    var b = use_browser();
    var is_sdk = (hopt.www_hola.sdk_browsers || []).indexOf(b) > -1 && (hopt.www_hola.sdk_os || []).indexOf(os) > -1;
    var has_svc = E._is_installed && E._is_installed.svc || opt && opt.has_svc;
    if (is_mac) {
      if (window.location.pathname == '/') {
        return hopt.www_hola.mac_installer_hola2eb + '?ver=' + versions.mac_installer;
      }
      if (is_mac_install_flow(_hopt, opt)) return hopt.www_hola.mac_installer;
      if (is_lum_promo(opt) || is_uninstall_flow(opt) || is_extension_flow(opt) || is_install_flow(opt) || is_firefox_flow(opt) || is_opera_flow(opt) || is_chrome_flow(opt) || is_edge_flow(opt) || is_banner_flow(opt) || is_email_flow(opt) || is_no_consent_flow(opt) || is_ios_flow(opt)) {
        file_name = 'HolaVPN-' + versions.mac + (versions.mac_build ? '-' + versions.mac_build : '');
        if (opt && opt.beta) {
          file_name = 'HolaVPN2E-' + versions.iosmac2e + '-' + versions.iosmac2e_build;
        }
      } else {
        file_name = 'HolaVPN2E-' + versions.iosmac2e + '-' + versions.iosmac2e_build + (has_svc || is_sdk ? hopt.www_hola.sdk_app_name_dmg : hopt.www_hola.no_sdk_app_name_dmg || '');
      }
      return file_name + '.dmg';
    }
    var nosdk = opt && opt.svc_info && opt.svc_info.appid == 'win_hola.noconsent.hola.org';
    var is_installer_v2 = E.is_win_installer_v2(_hopt, sys);
    var add_campaign;
    if (is_lum_promo(opt)) {
      return is_agreed(_hopt, opt) ? 'Hola-Setup-Pro-Agreed.exe' : 'Hola-Setup-Pro.exe';
    } else if (is_online_vpn_flow(opt)) {
      file_name = 'Hola-Setup-VPN.exe';
      add_campaign = true;
    } else if (is_web_installer_flow(opt)) {
      file_name = 'Hola-Setup-Web.exe';
      add_campaign = true;
    } else if (is_uninstall_flow(opt)) {
      file_name = is_agreed(_hopt, opt) ? 'Hola-Setup-P2-Agreed.exe' : 'Hola-Setup-P2.exe';
    } else if (is_ext_vpn_flow(_hopt, opt)) {
      file_name = is_agreed(_hopt, opt) ? 'Hola-Setup-Ext-VPN-Agreed.exe' : 'Hola-Setup-Ext-VPN.exe';
    } else if (is_opera_jn_flow(opt, b)) {
      file_name = is_agreed(_hopt, opt) ? 'Hola-Opera-Agreed.exe' : 'Hola-Opera.exe';
    } else if (is_firefox_jn_flow(opt, b)) {
      file_name = is_agreed(_hopt, opt) ? 'Hola-Firefox-Agreed.exe' : 'Hola-Firefox.exe';
    } else if (is_edge_jn_flow(opt, b)) {
      file_name = is_agreed(_hopt, opt) ? 'Hola-Edge-Agreed.exe' : 'Hola-Edge.exe';
    } else if (is_chrome_jn_flow(opt, b)) {
      file_name = is_agreed(_hopt, opt) ? 'Hola-Chrome-Agreed.exe' : 'Hola-Chrome.exe';
    } else if (is_extension_flow(opt)) {
      file_name = is_agreed(_hopt, opt) ? 'Hola-Setup-Ext-Agreed.exe' : 'Hola-Setup-Ext.exe';
    } else if (is_install_flow(opt)) {
      file_name = is_agreed(_hopt, opt) ? 'Hola-Setup-Ext2-Agreed.exe' : 'Hola-Setup-Ext2.exe';
    } else if (is_firefox_flow(opt)) {
      file_name = is_agreed(_hopt, opt) ? 'Hola-Setup-Firefox-Agreed.exe' : 'Hola-Setup-Firefox.exe';
    } else if (is_opera_flow(opt)) {
      file_name = is_agreed(_hopt, opt) ? 'Hola-Setup-Opera-Agreed.exe' : 'Hola-Setup-Opera.exe';
    } else if (is_chrome_flow(opt)) {
      file_name = is_agreed(_hopt, opt) ? 'Hola-Setup-Chrome-Agreed.exe' : 'Hola-Setup-Chrome.exe';
    } else if (is_edge_flow(opt)) {
      file_name = is_agreed(_hopt, opt) ? 'Hola-Setup-Edge-Agreed.exe' : 'Hola-Setup-Edge.exe';
    } else if (is_banner_flow(opt)) {
      file_name = is_agreed(_hopt, opt) ? 'Hola-Setup-Banner-Agreed.exe' : 'Hola-Setup-Banner.exe';
    } else if (is_email_flow(opt)) {
      file_name = is_agreed(_hopt, opt) ? 'Hola-Setup-Email-Agreed.exe' : 'Hola-Setup-Email.exe';
    } else if (is_no_consent_flow(opt)) {
      file_name = is_agreed(_hopt, opt) ? 'Hola-Setup-Noconsent-Agreed.exe' : 'Hola-Setup-Noconsent.exe';
    } else if (is_ios_flow(opt)) {
      file_name = is_agreed(_hopt, opt) ? 'Hola-Setup-Ios-Agreed.exe' : 'Hola-Setup-Ios.exe';
    } else if (is_agreed(_hopt, opt)) file_name = 'Hola-Setup-Agreed.exe';else {
      file_name = has_svc && !nosdk || is_sdk ? hopt.www_hola.sdk_app_name_exe : (is_installer_v2 ? hopt.www_hola.no_sdk_app_name_exe_v2 : hopt.www_hola.no_sdk_app_name_exe) || 'Hola-Setup.exe';
      add_campaign = true;
    }
    if (add_campaign) {
      var c_vpn = cookie.get('c_vpn');
      if (c_vpn && c_vpn != 'organic') {
        cmp_conf = get_cmp_conf(c_vpn, 'vpn');
        file_name = file_name.replace('.exe', (cmp_conf.infix || '') + '-C-' + c_vpn + '.exe');
      } else if (opt.from_navbar) {
        file_name = file_name.replace('.exe', '-C-HNB.exe');
      } else if (window.location.pathname == '/') {
        file_name = file_name.replace('.exe', '-C-HP' + (opt.after_dl_flow ? 'E' : '') + '.exe');
      }
    }
    if (is_installer_v2 && window.location.pathname == '/' && false) {
      var exp_ver = false ? 'a' : 'b';
      file_name = file_name.replace('Hola-Setup', 'Hola-Installer');
      file_name = file_name.replace('.exe', exp_ver + '.exe');
    }
    return file_name;
  };
  var b = user_agent.guess_browser();
  // XXX arik: simplify select_dl api and rm obsolete xxx_cws_plugin
  E.select_dl = function (xxx_cws_plugin, flow, premium) {
    var os = user_agent.guess().os;
    if (os == 'android') {
      return flow == 'accelerator' ? E.GDL.android_va : premium ? E.GDL.android_premium : E.GDL.android;
    }
    if (os == 'ios') return E.GDL.ios;
    if (os == 'ps') return E.GDL.ps;
    if (os == 'xbox') return E.GDL.xbox;
    if (b.browser == 'firefox') return E.GDL.firefox_signed;
    if (b.browser == 'chrome' && !!b.opera) return E.GDL.opera;
    if (b.browser == 'chrome') {
      if (os == 'windows') return E.GDL.windows;
      return E.GDL.chrome;
    }
    if (os == 'macos') return E.GDL.mac;
    return E.GDL.windows;
  };
  E.install_chrome_adblock = function (event) {
    if (document.documentElement.attributes.hola_adblocker_ext_present) {
      if (event) event.preventDefault();
      location.href = '/adremover';
    }
  };
  E.install_chrome_va = function (event) {
    if (document.documentElement.attributes.hola_va_ext_present) {
      if (event) event.preventDefault();
      location.href = '/accelerator';
    }
  };
  E.init_simple_download = function () {
    E.init_simple_download_by_class('detect-install2-vpn');
    E.init_simple_download_by_class('detect-install2-browser');
    E.init_simple_download_by_class('detect-install2-adblock');
    E.init_simple_download_by_class('detect-install2-accelerator');
  };
  function mousedown_cb(evt) {
    var el = evt.currentTarget;
    var product = el.getAttribute('data-product');
    var source = el.getAttribute('data-source');
    ga_send('event', 'www_site_load', 'click_' + product, source);
    perr({
      id: 'www_site_load_clicked',
      info: location.href,
      product_type: product,
      source: source
    });
  }
  E.init_simple_download_by_class = function (_class) {
    var dl = E.select_dl();
    var tags = document.getElementsByClassName(_class);
    var is_adblock = /adblock/.test(_class) && b.browser == 'chrome';
    var is_va = /accelerator/.test(_class) && b.browser == 'chrome';
    var product = is_adblock ? 'ab' : is_va ? 'va' : 'vpn';
    var tag;
    for (var i = 0; i < tags.length; i++) {
      tag = tags[i];
      if (tag.tagName != 'A' || tag.getAttribute('data-simple_download_initialized')) {
        continue;
      }
      tag.setAttribute('data-product', tag.getAttribute('data-product') || product);
      tag.setAttribute('data-source', tag.getAttribute('data-source') || tag.getAttribute('id') || '');
      tag.addEventListener('mousedown', mousedown_cb, false);
      if (is_adblock) tag.href = E.GDL[b.edge ? 'edge' : 'chrome'].adremover_url;else if (is_va) tag.href = E.GDL.chrome.va_url;else tag.href = dl.url;
      tag.rel = dl.cls;
      tag.setAttribute('data-simple_download_initialized', true);
    }
    init_reinstall_hover_behavior(_class);
  };
  function init_reinstall_hover_behavior(_class) {
    var reinstall_btn = document.querySelector('.link.' + _class);
    var icon_el = document.querySelector('.reinstall-icon-container');
    if (!reinstall_btn || !icon_el) return;
    reinstall_btn.addEventListener('mouseenter', function () {
      icon_el.classList.add('hovered');
    });
    reinstall_btn.addEventListener('mouseleave', function () {
      icon_el.classList.remove('hovered');
    });
  }
  E.uninit_simple_download = function (a) {
    for (var i = 0; i < a.length; i++) {
      a[i].removeEventListener('mousedown', mousedown_cb, false);
      a[i].removeAttribute('data-simple_download_initialized');
    }
  };
  E.redirect_to_store_needed = function () {
    return b.browser == 'chrome';
  };
  return E;
});